// extracted by mini-css-extract-plugin
export default {"base":"vp_rEGbm","status-pulse":"vp_KTAvF","error":"vp_Q8NPx","warning":"vp_36l6K","success":"vp_rl16M","spaced":"vp_HZrww"};